import { useState, useEffect } from "react";
import { collection, query, where, onSnapshot, orderBy } from "firebase/firestore";
import { db } from "../Config/Firebase";
import { useNavigate } from "react-router-dom";

const Boxcard = () => {
  const [totalUsers, setTotalUsers] = useState(0);
  const [last24hUsers, setLast24hUsers] = useState(0);
  const [totalPayment, setTotalPayment] = useState(0);
  const [totalRefund, setTotalRefund] = useState(0);
  const [maleCount, setMaleCount] = useState(0);
  const [femaleCount, setFemaleCount] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const usersRef = query(collection(db, "users"), orderBy("createdAt", "desc"));
    const unsubscribeUsers = onSnapshot(usersRef, (snapshot) => {
      setTotalUsers(snapshot.size);

      
      const usersData = snapshot.docs.map((doc) => doc.data());

      const now = Date.now();
      const twentyFourHoursAgo = now - 24 * 60 * 60 * 1000;

      const recentUsers = usersData.filter((user) => {
        let createdAtTime;

        if (user.createdAt?.toMillis) {
          createdAtTime = user.createdAt.toMillis();
        } else if (typeof user.createdAt === "number") {
          createdAtTime = user.createdAt;
        } else if (typeof user.createdAt === "string") {
          createdAtTime = new Date(user.createdAt).getTime();
        }

        return createdAtTime && createdAtTime >= twentyFourHoursAgo && createdAtTime <= now;
      });
      setLast24hUsers(recentUsers.length);

      const males = usersData.filter((user) => user.gender === "Male");
      const females = usersData.filter((user) => user.gender === "Female");
      setMaleCount(males.length);
      setFemaleCount(females.length);
    });

    const paymentsQuery = query(
      collection(db, "walletLogs"),
      where("reason", "==", "RECHARGE")
    );
    const unsubscribePayments = onSnapshot(paymentsQuery, (snapshot) => {
      let totalAmount = 0;
      snapshot.forEach((doc) => {
        const data = doc.data();
        if (data.amount && typeof data.amount === "number") {
          totalAmount += data.amount;
        }
      });
      setTotalPayment(totalAmount);
    });

    const refundQuery = query(
      collection(db, "withdrawals"),
      where("status", "==", "successful")
    );
    const unsubscribeRefund = onSnapshot(refundQuery, (snapshot) => {
      let totalRefundAmount = 0;
      snapshot.forEach((doc) => {
        const data = doc.data();
        if (data.receiveRupees && typeof data.receiveRupees === "number") {
          totalRefundAmount += data.receiveRupees;
        }
      });
      setTotalRefund(totalRefundAmount);
    });

    return () => {
      unsubscribeUsers();
      unsubscribePayments();
      unsubscribeRefund();
    };
  }, []);

  const handleTotalUser = () => navigate("/user-details");
  const handleTodayUser = () => navigate("/user-details/today");
  const handleMaleUser = () => navigate("/user-details/Male");
  const handleFemaleUser = () => navigate("/user-details/Female");

  return (
    <div className="Dashboard-1">
      <ul>
        <li onClick={handleTotalUser}>
          <div>
            <img
              src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
              alt="Total Users"
            />
            <div>
              <h3>Total Users</h3>
              <p>{totalUsers}</p>
            </div>
          </div>
        </li>

        <li>
          <div>
            <img
              src="https://cdn-icons-png.flaticon.com/512/1828/1828911.png"
              alt="Total Refund"
            />
            <div>
              <h3>Total Withdraw Amount</h3>
              <p>₹ {totalRefund}</p>
            </div>
          </div>
        </li>

        <li>
          <div>
            <img
              src="https://cdn-icons-png.flaticon.com/512/1170/1170576.png"
              alt="Total Payment"
            />
            <div>
              <h3>Total Payment</h3>
              <p>₹ {totalPayment}</p>
            </div>
          </div>
        </li>

        <li onClick={handleTodayUser}>
          <div>
            <img
              src="https://cdn-icons-png.flaticon.com/512/1828/1828884.png"
              alt="New Users"
            />
            <div>
              <h3>New Users (Last 24h)</h3>
              <p>{last24hUsers}</p>
            </div>
          </div>
        </li>

        <li onClick={handleFemaleUser}>
          <div>
            <img
              src="https://cdn-icons-png.flaticon.com/512/949/949646.png"
              alt="Female Users"
            />
            <div>
              <h3>Female Users</h3>
              <p>{femaleCount}</p>
            </div>
          </div>
        </li>

        <li onClick={handleMaleUser}>
          <div>
            <img
              src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
              alt="Male Users"
            />
            <div>
              <h3>Male Users</h3>
              <p>{maleCount}</p>
            </div>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default Boxcard;
